import { useIntl } from 'react-intl';

import { useDotSeriesTooltipHeaderContent } from './hooks/useDotSeriesTooltipHeaderContent.js';
import { safeGet } from '../../../../core/utils/safe-get.js';
import { useAxesFormatter } from '../../../hooks/useAxesFormatter.js';
import { useDotSeriesData } from '../../../hooks/useDotSeriesData.js';
import type { DotSeriesWithDatapoints } from '../../../types/xy-chart-internals.js';
import { type DotDatapoint } from '../../../types/xy-chart.js';
import { getTooltipFormatter } from '../utils/get-tooltip-formatter.js';
import { XYChartTooltipBody } from '../XYChartTooltipBody/XYChartTooltipBody.js';

export interface DotTooltipBodyProps {
  datapoint: DotDatapoint;
  series: DotSeriesWithDatapoints;
}

export function DotSeriesTooltipBody({
  datapoint,
  series,
}: DotTooltipBodyProps) {
  const axisIdToFormatter = useAxesFormatter();
  const { seriesToMetadata } = useDotSeriesData();
  const intl = useIntl();

  const { xAxis, yAxis } = safeGet(seriesToMetadata, series);

  const xFormatter = getTooltipFormatter(xAxis, axisIdToFormatter, intl);
  const yFormatter = getTooltipFormatter(yAxis, axisIdToFormatter, intl);

  const { text: textX, duration: durationX } = useDotSeriesTooltipHeaderContent(
    [datapoint.x0, datapoint.x1],
    xFormatter,
  );
  const { text: textY, duration: durationY } = useDotSeriesTooltipHeaderContent(
    [datapoint.y0, datapoint.y1],
    yFormatter,
  );
  return (
    <XYChartTooltipBody
      xAxisLabel={xAxis.label}
      yAxisLabel={yAxis.label}
      xAxisValue={textX}
      yAxisValue={textY}
      xAxisDuration={durationX}
      yAxisDuration={durationY}
    />
  );
}

DotSeriesTooltipBody['displayName'] = 'DotSeriesTooltipBody';
